import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-campaigns-facebook',
  templateUrl: './report-campaigns-facebook.component.html',
  styleUrls: ['./report-campaigns-facebook.component.css']
})
export class ReportCampaignsFacebookComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
